import style from './HeaderProfile.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { ArrowSelect } from '../../UI/ArrowSelect/ArrowSelect'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { closeAllSelect, openOrClose } from '../../Redux/Slices/Select/Select'
import { setUser } from '../../Redux/Slices/User'

export function HeaderProfile() {
    const user = useSelector(state => state.user.user)
    const isOpen = useSelector((state) => state.select.HeaderProfileSelect)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    function handleOut() {
        localStorage.clear()
        dispatch(setUser(null))
        navigate('/login')
    }
    
    const setIsOpen = () => {
        dispatch(openOrClose('HeaderProfileSelect'))
        isOpen && dispatch(closeAllSelect())
    }
    
    return <div className={`${style.headerProfile} select`} onClick={setIsOpen}>
        <div className={style.avatar}>
            {user?.avatar ? <img src="" alt="" />
            : <p>
                {user?.second_name[0].toUpperCase()}
                {user?.first_name[0].toUpperCase()}
            </p>}
        </div>
        <p className={style.name} >{user?.first_name} </p>
        <span className={style.filter__icon}><ArrowSelect/></span>
        <div className={`${style.table__filter__list} ${isOpen && style.active}`} >
            <Link to={process.env.REACT_APP_ADMIN_URL} target='_blank' className={`${style.table__list_item}`}>Настройки</Link>
            <div onClick={() => navigate('/help')} className={`${style.table__list_item}`}>Помощь</div>
            <div onClick={handleOut} className={`${style.table__list_item}`}>Выход из аккаунта</div>
        </div>        
    </div>
}

